import type { IconBaseProps, IconType } from 'react-icons';

type Props = IconBaseProps & {
	size: number;
};

export const MasterCardIcon: IconType = ({
	size = 24,
	...props
}): React.ReactNode => {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			{...props}
		>
			<title>Mastercard</title>
			<path
				d="M15.2378 6.10432H8.74298V17.8956H15.2378V6.10432Z"
				fill="#FF5A00"
			/>
			<path
				d="M9.17534 12C9.17534 9.60437 10.2898 7.47816 12 6.10437C10.7414 5.10437 9.15372 4.5 7.42194 4.5C3.31946 4.5 0 7.85437 0 12C0 16.1456 3.31946 19.5 7.42194 19.5C9.15372 19.5 10.7414 18.8956 12 17.8956C10.2874 16.5413 9.17534 14.3956 9.17534 12Z"
				fill="#EB001B"
			/>
			<path
				d="M24 12C24 16.1456 20.6805 19.5 16.5781 19.5C14.8463 19.5 13.2586 18.8956 12 17.8956C13.7318 16.5194 14.8247 14.3956 14.8247 12C14.8247 9.60437 13.7102 7.47816 12 6.10437C13.2562 5.10437 14.8439 4.5 16.5757 4.5C20.6805 4.5 24 7.87621 24 12Z"
				fill="#F79E1B"
			/>
		</svg>
	);
};
